import { render, staticRenderFns } from "./FHandler.vue?vue&type=template&id=1f658e27"
import script from "./FHandler.vue?vue&type=script&lang=js"
export * from "./FHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports